import React from "react";
import DynamicIcon from "../dynamic-icon";

const CardSelect = ({ children, options = [], onSelect, selected, multiple = false, size = "medium", viewOnly = false, cols = 1, className, fluid = false }) => {
    const handleChange = (option) => {
        onSelect(option);
    };
    const getCardClasses = (option) => {
        const classes = {
            "card-select": true,
            "card-select--multiple": multiple,
            "card-select--single": !multiple,
            "card-select--small": size === "small",
            "card-select--view-only": viewOnly,
            "card-select--selected": selected && (multiple ? selected?.some(i => i.id === option.id) : selected.id === option.id)
        }
        return Object.entries(classes).map(([key, value]) => value ? key : null).join(" ");
    }

    const getWrapperClasses = (option) => {
        const classes = {
            "card-select-wrapper": true,
            "card-select-wrapper--small": size === "small",
            [`card-select-wrapper--${cols}`]: true,
            "card-select-wrapper--fluid": fluid,
            [className]: className
        }
        return Object.entries(classes).map(([key, value]) => value ? key : null).join(" ");
    }

    return (
        <div className={getWrapperClasses()}>
            {options?.map((option) => (
                <label
                    className={getCardClasses(option)}
                    key={option.id}>
                    {(option.image || option?.customAttributes?._productImage) && (
                        <div className="card-select__image">
                            <img src={option?.image || option?.customAttributes?._productImage} alt="Card Image" />
                        </div>
                    )}

                    {option?.icon && (
                        <div className="card-select__icon">
                            <DynamicIcon icon={option?.icon} />
                        </div>
                    )}

                    <div className="card-select__content">

                        <p className="card-select__title">{option.title || option.name || option.label}</p>
                        {option.category || option.type && (
                            <p className="card-select__category">{option.category || option.type || option.customAttributes?._item_variant}</p>
                        )}

                        {typeof children === 'function' ? children(option) : children}
                    </div>
                    <div className="card-select__input">
                        <div className={`card-select__marker ${multiple ? "card-select__marker--multiple" : "card-select__marker--single"} ${selected && (multiple ? selected?.some(i => i.id === option.id) : selected.id === option.id) ? "card-select__marker--selected" : ""}`}>

                            {/* IDK maybe mobe  */}
                            {multiple && (
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 12.5L10 16.5L18 8.5" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            )}

                        </div>
                        <input
                            type={multiple ? "checkbox" : "radio"}
                            className="card-select__checkbox"
                            checked={multiple ? (Array.isArray(selected) && selected.includes(option.id)) : selected === option.id}
                            onChange={() => handleChange(option)}
                            name="card-select-group"
                        />
                    </div>
                </label>
            ))}
        </div>
    )
}

export default CardSelect;